import React from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { BatchPicker } from "./BatchPicker";

export const BatchChangeDialog = ({
  open, onOpenChange,
  selectedEnrollment,
  batches, styles, studios = [], instructors = [], masterInstructors = [],
  newBatchId,
  onCheckBatchChange,
  onConfirm,
  batchChangeWarning,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[85vh]">
        <DialogHeader>
          <DialogTitle>Change Batch</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="p-3 bg-slate-50 rounded-lg">
            <p className="text-sm text-slate-600">Current Batch:</p>
            <p className="font-medium">{selectedEnrollment?.batch?.name}</p>
          </div>

          <div className="space-y-2">
            <Label>Select New Batch</Label>
            <BatchPicker
              value={newBatchId}
              batches={batches}
              styles={styles}
              studios={studios}
              instructors={instructors}
              masterInstructors={masterInstructors}
              excludeBatchId={selectedEnrollment?.batch_id}
              placeholder="Choose Batch"
              testIdPrefix="change-batch"
              onChange={onCheckBatchChange}
            />
          </div>

          {batchChangeWarning && (
            <div className="p-4 bg-amber-50 border border-amber-200 rounded-xl">
              <div className="flex items-start gap-2">
                <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5" />
                <div>
                  <p className="font-medium text-amber-800">Warning</p>
                  <ul className="text-sm text-amber-700 mt-1 list-disc list-inside">
                    {batchChangeWarning.map((w, i) => (
                      <li key={`warn-${i}-${typeof w === "string" ? w.slice(0, 20) : ""}`}>{w}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )}

          <div className="flex gap-3">
            <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1 rounded-full">
              Cancel
            </Button>
            <Button onClick={onConfirm} disabled={!newBatchId} className="flex-1 rounded-full bg-primary" data-testid="confirm-batch-change-btn">
              Confirm Change
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BatchChangeDialog;
